export default __webpack_public_path__ + "static/media/documentTime.720eb0ba.svg";